import { Accordion } from '@cleartax/wg-library-accordian';
import { Text } from '@cleartax/wg-library-typography';
interface ISidebarDropDown {
  contentHeader: string;
  contentArr: Array<{
    name: string;
    href: string;
  }>;
  headerClasses?: string;
  className?: string;
  onClickCB?: () => void;
}

export const SidebarDropDown: React.FC<ISidebarDropDown> = ({
  contentHeader,
  contentArr,
  headerClasses = 'text-base text-brand-1000 mb-4 font-semibold',
  className = 'border-y-sm border-y-grey-300 border-dashed pl-3',
  onClickCB,
}) => {
  return (
    <div className={className}>
      <Accordion
        header={contentHeader}
        accordianHeaderEleClasses={headerClasses}
      >
        {contentArr.map((item, idx) => {
          return (
            <Text
              type="a"
              href={item.href}
              key={item.name}
              weight="normal"
              className={`text-brand-1000 cursor-pointer block py-3 ${
                idx === 0 ? 'pt-0' : ''
              } pl-4 hover:text-brand-700`}
              textSize="base"
              {...(item.name === 'Logout' && onClickCB
                ? { onClick: () => onClickCB() }
                : {})}
            >
              {item.name}
            </Text>
          );
        })}
      </Accordion>
    </div>
  );
};
